import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useForm } from '@laramie/ui';
import { InputEntidad, InputEjercicio, InputTasa, InputSubTasa, InputLista, FormLabel, Modal, FormError, Select } from '../../common';
import {isValidNumber} from '../../../utils/validator';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import {isEmpty} from 'validator';
import {Accordion} from "../../common";

const SubTasaImputacionModal = (props) => {

    const entityInit = {
        id: 0,
        idTasa: 0,
        idSubTasa: 0,
        ejercicio: '',
        idTipoCuota: 0,
        idCuentaContable: 0,
        idCuentaContableAnterior: 0,
        idCuentaContableFutura: 0,
        idJurisdiccionActual: 0,
        idRecursoPorRubroActual: 0,
        idJurisdiccionAnterior: 0,
        idRecursoPorRubroAnterior: 0,
        idJurisdiccionFutura: 0,
        idRecursoPorRubroFutura: 0,
        codigoFormaPago: "",
        codigoTipoRecaudacion: ""
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        lists: {
            Jurisdiccion: [],
            RecursoPorRubro: [],
            CuentaContable: []
        },
    });

    const [ejercicios, setEjercicios] = useState({
        anterior: '',
        actual: '',
        futuro: ''
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity, lists: props.data.lists};
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            ejercicio: props.data.entity.ejercicio,
            idTipoCuota: props.data.entity.idTipoCuota,
            idCuentaContable: props.data.entity.idCuentaContable,
            idCuentaContableAnterior: props.data.entity.idCuentaContableAnterior,
            idCuentaContableFutura: props.data.entity.idCuentaContableFutura,
            idJurisdiccionActual: props.data.entity.idJurisdiccionActual,
            idRecursoPorRubroActual: props.data.entity.idRecursoPorRubroActual,
            idJurisdiccionAnterior: props.data.entity.idJurisdiccionAnterior,
            idRecursoPorRubroAnterior: props.data.entity.idRecursoPorRubroAnterior,
            idJurisdiccionFutura: props.data.entity.idJurisdiccionFutura,
            idRecursoPorRubroFutura: props.data.entity.idRecursoPorRubroFutura,
            codigoFormaPago: props.data.entity.codigoFormaPago,
            codigoTipoRecaudacion: props.data.entity.codigoTipoRecaudacion
        });
        const ejercicio = props.data.entity.ejercicio;
        const anterior = props.data.entity.ejercicio;
        const futuro = props.data.entity.ejercicio;
        // const anterior = (parseInt(ejercicio) - 1).toString();
        // const futuro = (parseInt(ejercicio) + 1).toString();
        setEjercicios({
            anterior: anterior,
            actual: ejercicio,
            futuro: futuro
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        ejercicio: '',
        idTipoCuota: 0,
        idCuentaContable: 0,
        idCuentaContableAnterior: 0,
        idCuentaContableFutura: 0,
        idJurisdiccionActual: 0,
        idRecursoPorRubroActual: 0,
        idJurisdiccionAnterior: 0,
        idRecursoPorRubroAnterior: 0,
        idJurisdiccionFutura: 0,
        idRecursoPorRubroFutura: 0,
        codigoFormaPago: '',
        codigoTipoRecaudacion: ''
    });

    const [imputacionOpen, setImputacionOpen] = useState(true);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (Object.keys(getErrors()).length > 0) setImputacionOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.ejercicio = formValues.ejercicio;
            row.idTipoCuota = formValues.idTipoCuota;
            row.idCuentaContable = formValues.idCuentaContable;
            row.idCuentaContableAnterior = formValues.idCuentaContableAnterior;
            row.idCuentaContableFutura = formValues.idCuentaContableFutura;
            row.idJurisdiccionActual = formValues.idJurisdiccionActual;
            row.idRecursoPorRubroActual = formValues.idRecursoPorRubroActual;
            row.idJurisdiccionAnterior = formValues.idJurisdiccionAnterior;
            row.idRecursoPorRubroAnterior = formValues.idRecursoPorRubroAnterior;
            row.idJurisdiccionFutura = formValues.idJurisdiccionFutura;
            row.idRecursoPorRubroFutura = formValues.idRecursoPorRubroFutura;
            row.codigoFormaPago = formValues.codigoFormaPago;
            row.codigoTipoRecaudacion = formValues.codigoTipoRecaudacion;

            props.onConfirm(row);
        }
        ;
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.ejercicio.length <= 0) errors.ejercicio = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.idTipoCuota <= 0) errors.idTipoCuota = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (isEmpty(formValues.codigoFormaPago)) errors.codigoFormaPago = VALIDATION_MESSAGE.REQUIRED;
        if (isEmpty(formValues.codigoTipoRecaudacion)) errors.codigoTipoRecaudacion = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    return (
        <>

            <Modal
                size="xl"
                title="Imputación"
                tipName={TIPS.NAME.MODALS.IMPUTACION_SUB_TASA_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Imputación" open={imputacionOpen} onToggle={setImputacionOpen}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idTasa" className="form-label">Tasa</label>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idTasa}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idSubTasa" className="form-label">Sub tasa</label>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idSubTasa}
                                                    disabled={true}
                                                    idTasa={formValues.idTasa}
                                                />
                                            </div>
                                            <div className="mb-3 col-2">
                                                <FormLabel htmlFor="ejercicio" required>Ejercicio</FormLabel>
                                                <InputEjercicio
                                                    name="ejercicio"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('ejercicio') ? 'is-invalid' : ''}`}
                                                    value={formValues.ejercicio}
                                                    onChange={({target}) => {
                                                        const ejercicio = target.value;
                                                        formSet({...formValues, ejercicio: ejercicio});
                                                        if (ejercicio.length === 4 && isValidNumber(ejercicio, true)) {
                                                            const anterior = (parseInt(ejercicio) - 1).toString();
                                                            const futuro = (parseInt(ejercicio) + 1).toString();
                                                            setEjercicios({
                                                                anterior: anterior,
                                                                actual: ejercicio,
                                                                futuro: futuro
                                                            });
                                                        } else {
                                                            setEjercicios({
                                                                anterior: '',
                                                                actual: '',
                                                                futuro: ''
                                                            });
                                                        }
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('ejercicio')} />
                                            </div>
                                            <div className="mb-3 col-3">
                                                <FormLabel htmlFor="idTipoCuota" required>Tipo
                                                    cuota</FormLabel>
                                                <InputLista
                                                    name="idTipoCuota"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoCuota') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoCuota}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo de cuota"
                                                    lista="TipoCuota"
                                                    showCode={true}
                                                />
                                                <FormError message={errorOf('idTipoCuota')} />
                                            </div>
                                            <div className="mb-3 col-3">
                                                <FormLabel htmlFor="codigoFormaPago" required>Código forma
                                                    de pago</FormLabel>
                                                <Select
                                                    name="codigoFormaPago"
                                                    className={`form-control ${errorOf('codigoFormaPago') ? 'is-invalid' : ''}`}
                                                    options={[
                                                        { value: '', label: '' },
                                                        { value: '1', label: '1 - Percibido diferido del devengado' },
                                                        { value: '5', label: '5 - Percibido y devengado inmediato' }
                                                    ]}
                                                    value={formValues.codigoFormaPago}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('codigoFormaPago')} />
                                            </div>
                                            <div className="mb-3 col-4">
                                                <FormLabel htmlFor="codigoTipoRecaudacion" required>Código
                                                    tipo de recaudación</FormLabel>
                                                <Select
                                                    name="codigoTipoRecaudacion"
                                                    className={`form-control ${errorOf('codigoTipoRecaudacion') ? 'is-invalid' : ''}`}
                                                    options={[
                                                        { value: '', label: '' },
                                                        { value: 'P', label: 'P - Presupuestario' },
                                                        { value: 'E', label: 'E - Extrapresupuestario' }
                                                    ]}
                                                    value={formValues.codigoTipoRecaudacion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('codigoTipoRecaudacion')} />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idCuentaContable"
                                                       className="form-label">Cuenta</label>
                                                <InputEntidad
                                                    name="idCuentaContable"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idCuentaContable}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Cuenta actual"
                                                    entidad="CuentaContable"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.actual)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.CuentaContable}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idJurisdiccionActual" className="form-label">Jurisdicción
                                                    actual</label>
                                                <InputEntidad
                                                    name="idJurisdiccionActual"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idJurisdiccionActual}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Jurisdicción actual"
                                                    entidad="Jurisdiccion"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.actual)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.Jurisdiccion}
                                                />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <label htmlFor="idRecursoPorRubroActual" className="form-label">Recurso
                                                    por rubro actual</label>
                                                <InputEntidad
                                                    name="idRecursoPorRubroActual"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idRecursoPorRubroActual}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Recurso por rubro actual"
                                                    entidad="RecursoPorRubro"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.actual)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.RecursoPorRubro}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idCuentaContableAnterior" className="form-label">Cuenta
                                                    anterior</label>
                                                <InputEntidad
                                                    name="idCuentaContableAnterior"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idCuentaContableAnterior}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Cuenta anterior"
                                                    entidad="CuentaContable"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.anterior)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.CuentaContable}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idJurisdiccionAnterior" className="form-label">Jurisdicción
                                                    anterior</label>
                                                <InputEntidad
                                                    name="idJurisdiccionAnterior"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idJurisdiccionAnterior}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Jurisdicción anterior"
                                                    entidad="Jurisdiccion"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.anterior)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.Jurisdiccion}
                                                />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <label htmlFor="idRecursoPorRubroAnterior" className="form-label">Recurso
                                                    por rubro anterior</label>
                                                <InputEntidad
                                                    name="idRecursoPorRubroAnterior"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idRecursoPorRubroAnterior}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Recurso por rubro anterior"
                                                    entidad="RecursoPorRubro"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.anterior)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.RecursoPorRubro}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idCuentaContableFutura" className="form-label">Cuenta
                                                    futura</label>
                                                <InputEntidad
                                                    name="idCuentaContableFutura"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idCuentaContableFutura}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Cuenta futura"
                                                    entidad="CuentaContable"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.futuro)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.CuentaContable}
                                                />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <label htmlFor="idJurisdiccionFutura" className="form-label">Jurisdicción
                                                    futura</label>
                                                <InputEntidad
                                                    name="idJurisdiccionFutura"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idJurisdiccionFutura}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Jurisdicción futura"
                                                    entidad="Jurisdiccion"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.futuro)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.Jurisdiccion}
                                                />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <label htmlFor="idRecursoPorRubroFutura" className="form-label">Recurso
                                                    por rubro futuro</label>
                                                <InputEntidad
                                                    name="idRecursoPorRubroFutura"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idRecursoPorRubroFutura}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Recurso por rubro futuro"
                                                    entidad="RecursoPorRubro"
                                                    onFormat={(row) => (row) ? `${row.agrupamiento} - ${row.nombre} (${row.ejercicio})` : ''}
                                                    filter={(row) => {
                                                        return (row.ejercicio === ejercicios.futuro)
                                                    }}
                                                    columns={[
                                                        {
                                                            Header: 'Agrupamiento',
                                                            accessor: 'agrupamiento',
                                                            width: '20%'
                                                        },
                                                        {Header: 'Nombre', accessor: 'nombre', width: '60%'},
                                                        {Header: 'Ejercicio', accessor: 'ejercicio', width: '20%'}
                                                    ]}
                                                    memo={null}
                                                    data={state.lists.RecursoPorRubro}
                                                />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de imputaciones"
                                            processKey={props.processKey}
                                            entidad="SubTasaImputacion"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

SubTasaImputacionModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

SubTasaImputacionModal.defaultProps = {
    disabled: false
};

export default SubTasaImputacionModal;